import React from "react";
import PropTypes from "prop-types";
import "./AvatarGroup.scss";
import Avatar from "../avatar/Avtar";

const AvatarGroup = ({ avatars, max, size, shape }) => {
  const displayedAvatars = max ? avatars.slice(0, max) : avatars;
  const remainingCount = avatars.length - displayedAvatars.length;

  return (
    <div className="avatar-group">
      {displayedAvatars.map((avatar, index) => (
        <Avatar
          key={index + 1}
          src={avatar?.src}
          alt={avatar?.alt || avatar?.label}
          size={size}
          shape={shape}
        />
      ))}
      {remainingCount > 0 && (
        <div className={`avatar remaining-avatar ${size} ${shape}`}>
          +{remainingCount}
        </div>
      )}
    </div>
  );
};

AvatarGroup.propTypes = {
  avatars: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ).isRequired,
  max: PropTypes.number,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  shape: PropTypes.oneOf(["circle", "square"]),
};

AvatarGroup.defaultProps = {
  max: 5,
  size: "medium",
  shape: "circle",
};

export default AvatarGroup;